class MediaGallery extends HTMLElement {
    constructor() {
        super(),
        this.elements = {
            liveRegion: this.querySelector('[id^="GalleryStatus"]'),
            viewer: this.querySelector('[id^="GalleryViewer"]'),
            thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
        },
        this.mql = window.matchMedia("(min-width: 750px)"),
        this.elements.thumbnails && (this.elements.viewer.addEventListener("slideChanged", debounce(this.onSlideChanged.bind(this), 500)),
        this.elements.thumbnails.querySelectorAll("[data-target]").forEach((t => {
            t.querySelector("button").addEventListener("click", this.setActiveMedia.bind(this, t.dataset.target, !1))
        }
        )),
        this.dataset.desktopLayout.includes("thumbnail") && this.mql.matches && this.removeListSemantic())
    }
    onSlideChanged(t) {
        const e = this.elements.thumbnails.querySelector(`[data-target="${t.detail.currentElement.dataset.mediaId}"]`);
        this.setActiveThumbnail(e)
    }
    setActiveMedia(t, e) {
        const i = this.elements.viewer.querySelector(`[data-media-id="${t}"]`) || this.elements.viewer.querySelector("[data-media-id]");
        if (!i)
            return;
        if (this.elements.viewer.querySelectorAll("[data-media-id]").forEach((t => {
            t.classList.remove("is-active")
        }
        )),
        i?.classList?.add("is-active"),
        e) {
            if (i.parentElement.firstChild !== i && i.parentElement.prepend(i),
            this.elements.thumbnails) {
                const e = this.elements.thumbnails.querySelector(`[data-target="${t}"]`);
                e.parentElement.firstChild !== e && e.parentElement.prepend(e)
            }
            this.elements.viewer.slider && this.elements.viewer.resetPages()
        }
        if (this.preventStickyHeader(),
        window.setTimeout(( () => {
            this.mql.matches && !this.elements.thumbnails || i.parentElement.scrollTo({
                left: i.offsetLeft
            }),
            this.elements.thumbnails && "stacked" !== this.dataset.desktopLayout || i.scrollIntoView({
                behavior: "smooth"
            })
        }
        )),
        this.playActiveMedia(i),
        !this.elements.thumbnails)
            return;
        const s = this.elements.thumbnails.querySelector(`[data-target="${t}"]`);
        this.setActiveThumbnail(s),
        s && this.announceLiveRegion(i, s.dataset.mediaPosition)
    }
    setActiveThumbnail(t) {
        this.elements.thumbnails && t && (this.elements.thumbnails.querySelectorAll("button").forEach((t => t.removeAttribute("aria-current"))),
        t.querySelector("button").setAttribute("aria-current", !0),
        this.elements.thumbnails.slider.scrollTo({
            top: t.offsetTop
        }))
    }
    announceLiveRegion(t, e) {
        const i = t.querySelector(".product__modal-opener--image img");
        i && (i.onload = () => {
            this.elements.liveRegion.setAttribute("aria-hidden", !1),
            this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace("[index]", e),
            setTimeout(( () => {
                this.elements.liveRegion.setAttribute("aria-hidden", !0)
            }
            ), 2e3)
        }
        ,
        i.src = i.src)
    }
    playActiveMedia(t) {
        window.pauseAllMedia();
        const e = t.querySelector(".deferred-media");
        e && e.loadContent(!1)
    }
    preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector("sticky-header"),
        this.stickyHeader && this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"))
    }
    removeListSemantic() {
        this.elements.viewer.slider && (this.elements.viewer.slider.setAttribute("role", "presentation"),
        this.elements.viewer.sliderItems.forEach((t => t.setAttribute("role", "presentation"))))
    }
}
customElements.define("media-gallery", MediaGallery);
class SwatchMedia extends MediaGallery {
    constructor() {
        super(),
        this.elements.thumbnails.querySelectorAll("[data-target-alt]").forEach((t => {
            t.querySelector("button").addEventListener("click", this.setActiveMedia.bind(this, t.dataset.targetAlt, !1))
        }
        ))
    }
    onSlideChanged(t) {
        const e = this.elements.thumbnails.querySelector(`[data-target-alt="${t.detail.currentElement.dataset.alt}"]`);
        this.setActiveThumbnail(e)
    }
    setActiveMedia(t, e) {
        const i = this.elements.viewer.querySelector(`[data-alt="${t}"]`) || this.elements.viewer.querySelector("[data-alt]");
        if (!i)
            return;
        if (this.elements.viewer.querySelectorAll("[data-media-id]").forEach((t => {
            t.classList.remove("is-active")
        }
        )),
        i?.classList?.add("is-active"),
        e) {
            if (i.parentElement.firstChild !== i && i.parentElement.prepend(i),
            this.elements.thumbnails) {
                const e = this.elements.thumbnails.querySelector(`[data-target-alt="${t}"]`);
                e.parentElement.firstChild !== e && e.parentElement.prepend(e)
            }
            this.elements.viewer.slider && this.elements.viewer.resetPages()
        }
        if (this.preventStickyHeader(),
        window.setTimeout(( () => {
            this.mql.matches && !this.elements.thumbnails || i.parentElement.scrollTo({
                left: i.offsetLeft
            }),
            this.elements.thumbnails && "stacked" !== this.dataset.desktopLayout || i.scrollIntoView({
                behavior: "smooth"
            })
        }
        )),
        this.playActiveMedia(i),
        !this.elements.thumbnails)
            return;
        const s = this.elements.thumbnails.querySelector(`[data-target-alt="${t}"]`);
        this.setActiveThumbnail(s),
        s && this.announceLiveRegion(i, s.dataset.mediaPosition)
    }
}
customElements.define("swatch-media", SwatchMedia);
class VerticalSlider extends HTMLElement {
    constructor() {
        super(),
        this.slider = this.querySelector('[id^="Slider-"]'),
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]'),
        this.enableSliderLooping = !1,
        this.currentPageElement = this.querySelector(".slider-counter--current"),
        this.pageTotalElement = this.querySelector(".slider-counter--total"),
        this.prevButton = this.querySelector('button[name="previous"]'),
        this.nextButton = this.querySelector('button[name="next"]'),
        this.slider && this.nextButton && (this.initPages(),
        new ResizeObserver((t => this.initPages())).observe(this.slider),
        this.slider.addEventListener("scroll", this.update.bind(this)),
        this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
        this.nextButton.addEventListener("click", this.onButtonClick.bind(this)))
    }
    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter((t => t.clientWidth > 0)),
        this.sliderItemsToShow.length < 2 || (this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop,
        this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset),
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1,
        this.update())
    }
    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]'),
        this.initPages()
    }
    update() {
        if (!this.slider || !this.nextButton)
            return;
        const t = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1,
        this.currentPageElement && this.pageTotalElement && (this.currentPageElement.textContent = this.currentPage,
        this.pageTotalElement.textContent = this.totalPages),
        this.currentPage != t && this.dispatchEvent(new CustomEvent("slideChanged",{
            detail: {
                currentPage: this.currentPage,
                currentElement: this.sliderItemsToShow[this.currentPage - 1]
            }
        })),
        this.enableSliderLooping || (this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.slider.scrollTop ? this.prevButton.setAttribute("disabled", "disabled") : this.prevButton.removeAttribute("disabled"),
        this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) ? this.nextButton.setAttribute("disabled", "disabled") : this.nextButton.removeAttribute("disabled"))
    }
    isSlideVisible(t, e=0) {
        const i = this.slider.clientHeight + this.slider.scrollTop - e;
        return t.offsetTop + t.clientHeight <= i && t.offsetTop >= this.slider.scrollTop
    }
    onButtonClick(t) {
        t.preventDefault();
        const e = t.currentTarget.dataset.step || 1;
        this.slideScrollPosition = "next" === t.currentTarget.name ? this.slider.scrollTop + e * this.sliderItemOffset : this.slider.scrollTop - e * this.sliderItemOffset,
        this.setSlidePosition(this.slideScrollPosition)
    }
    setSlidePosition(t) {
        this.slider.scrollTo({
            top: t
        })
    }
}
customElements.define("vertical-slider", VerticalSlider),
customElements.get("product-form") || customElements.define("product-form", class extends HTMLElement {
    constructor() {
        super(),
        this.form = this.querySelector("form"),
        this.form.querySelector("[name=id]").disabled = !1,
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer"),
        this.submitButton = this.querySelector('[type="submit"]'),
        document.querySelector("cart-drawer") && this.submitButton.setAttribute("aria-haspopup", "dialog"),
        this.hideErrors = "true" === this.dataset.hideErrors
    }
    onSubmitHandler(t) {
        if (t.preventDefault(),
        "true" === this.submitButton.getAttribute("aria-disabled"))
            return;
        this.handleErrorMessage(),
        this.submitButton.setAttribute("aria-disabled", !0),
        this.submitButton.classList.add("loading"),
        this.querySelector(".loading-overlay__spinner").classList.remove("hidden");
        const e = fetchConfig("javascript");
        e.headers["X-Requested-With"] = "XMLHttpRequest",
        delete e.headers["Content-Type"];
        const i = new FormData(this.form);
        this.cart && (i.append("sections", this.cart.getSectionsToRender().map((t => t.id))),
        i.append("sections_url", window.location.pathname),
        this.cart.setActiveElement(document.activeElement)),
        e.body = i,
        fetch(`${routes.cart_add_url}`, e).then((t => t.json())).then((t => {
            if (t.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                    source: "product-form",
                    productVariantId: i.get("id"),
                    errors: t.errors || t.description,
                    message: t.message
                }),
                this.handleErrorMessage(t.description);
                const e = this.submitButton.querySelector(".sold-out-message");
                if (!e)
                    return;
                return this.submitButton.setAttribute("aria-disabled", !0),
                this.submitButton.querySelector("span").classList.add("hidden"),
                e.classList.remove("hidden"),
                void (this.error = !0)
            }
            if (!this.cart)
                return void (window.location = window.routes.cart_url);
            this.error || publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: i.get("id"),
                cartData: t
            }),
            this.error = !1;
            const e = this.closest("quick-add-modal");
            e ? (document.body.addEventListener("modalClosed", ( () => {
                setTimeout(( () => {
                    this.cart.renderContents(t)
                }
                ))
            }
            ), {
                once: !0
            }),
            e.hide(!0)) : this.cart.renderContents(t)
        }
        )).catch((t => {
            console.error(t)
        }
        )).finally(( () => {
            this.submitButton.classList.remove("loading"),
            this.cart && this.cart.classList.contains("is-empty") && this.cart.classList.remove("is-empty"),
            this.error || this.submitButton.removeAttribute("aria-disabled"),
            this.querySelector(".loading-overlay__spinner").classList.add("hidden")
        }
        ))
    }
    handleErrorMessage(t=!1) {
        this.hideErrors || (this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper"),
        this.errorMessageWrapper && (this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message"),
        this.errorMessageWrapper.toggleAttribute("hidden", !t),
        t && (this.errorMessage.textContent = t)))
    }
}
),
customElements.get("product-info") || customElements.define("product-info", class extends HTMLElement {
    constructor() {
        super(),
        this.input = this.querySelector(".quantity__input"),
        this.currentVariant = this.querySelector(".product-variant-id"),
        this.variantSelects = this.querySelector("variant-radios"),
        this.submitButton = this.querySelector('[type="submit"]')
    }
    cartUpdateUnsubscriber = void 0;
    variantChangeUnsubscriber = void 0;
    connectedCallback() {
        this.input && (this.quantityForm = this.querySelector(".product-form__quantity"),
        this.quantityForm && (this.setQuantityBoundries(),
        this.dataset.originalSection || (this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this))),
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (t => {
            const e = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
            t.data.sectionId === e && (this.updateQuantityRules(t.data.sectionId, t.data.html),
            this.setQuantityBoundries())
        }
        ))));
        let t = new MutationObserver((e => {
            const i = this.querySelector(".dpo-container");
            if (i) {
                const colorContainer = i.querySelector('.color');
                const optionData = document.getElementById('dynamicOptions');
                const swatchData = JSON.parse(optionData.querySelector('#productSwatch').textContent);
                if (colorContainer) {
                  const colorElm = document.querySelector('.dpo-container .color input:checked');
                  if (!colorElm) return;
                  const label = i.querySelector(`label[for="${colorElm.id}"]`);
                  if (!label) return;
                  const color = label.textContent.trim();
                  if (!color) return;
                  fetch(window.Shopify.routes.root + `products/${swatchData[0].handle}.js`)
                  .then(response => response.json())
                  .then(product => {
                      // get the variant where title equals to current color
                      if (!product.variants) return;
                      const variant = product.variants.find((o) => o.title?.trim() === color);
                      if (!variant) return;
                      const addToCarBtn = document.querySelector('button[name="add"]');
                      const form = addToCarBtn.closest('form');
                      if (!form) return;
                      if (!variant.sku) return;
                      const inputElem = document.createElement('input');
                      inputElem.type = 'hidden';
                      inputElem.name = 'properties[Fabric]';
                      inputElem.value = variant.sku;
                      form.append(inputElem);
                  });
                }
                const e = i.querySelector(".size_width")
                  , s = i.querySelector(".fullness-desc");
                if (s) {
                    const t = document.createElement("div");
                    t.innerHTML = '<p>For more details about fullness, please <a id="fullness_instr_opener" href="javascript:void(0)">click here</a>.</p>',
                    s.appendChild(t);
                    const e = document.getElementById("fullness_instr_opener");
                    e && e.addEventListener("click", (t => {
                        t.preventDefault();
                        const e = document.getElementById("PopupModal-fullness");
                        e && e.show(t.target)
                    }
                    ))
                }
                if (!e)
                    return void t.disconnect();
                const r = document.getElementById("PopupModal-2");
                if (!this.dataset.sizeNotes && !r)
                    return void t.disconnect();
                const n = e.closest("table")
                  , a = document.createElement("div");
                a.style.padding = ".5rem",
                "how-to-measure-curtains-drapes" === r.dataset.handle ? a.innerHTML = `${this.dataset.sizeNotes ? `<p>${this.dataset.sizeNotes}</p>` : ""}${r ? '<p>Curtain length measurement varies by header style. <a id="measure_instr_opener" href="javascript:void(0)">Click here to see our step-by-step instructions</a>.</p>' : ""}` : a.innerHTML = `${this.dataset.sizeNotes ? `<p>${this.dataset.sizeNotes}</p>` : ""}${r ? '<p>Need help measuring? To view our step-by-step instructions, <a id="measure_instr_opener" href="javascript:void(0)">Click here</a>.</p>' : ""}`,
                n && n.appendChild(a);
                const o = document.getElementById("measure_instr_opener");
                o && o.addEventListener("click", (t => {
                    t.preventDefault(),
                    r && r.show(t.target)
                }
                )),
                t.disconnect()
            }
        }
        ));
        t.observe(this, {
            attributes: !0,
            childList: !0,
            subtree: !0
        })
    }
    disconnectedCallback() {
        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber(),
        this.variantChangeUnsubscriber && this.variantChangeUnsubscriber()
    }
    setQuantityBoundries() {
        const t = {
            cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
            min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
            max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
            step: this.input.step ? parseInt(this.input.step) : 1
        };
        let e = t.min;
        const i = null === t.max ? t.max : t.max - t.cartQuantity;
        null !== i && (e = Math.min(e, i)),
        t.cartQuantity >= t.min && (e = Math.min(e, t.step)),
        this.input.min = e,
        this.input.max = i,
        this.input.value = e,
        publish(PUB_SUB_EVENTS.quantityUpdate, void 0)
    }
    fetchQuantityRules() {
        this.currentVariant && this.currentVariant.value && (this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden"),
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`).then((t => t.text())).then((t => {
            const e = (new DOMParser).parseFromString(t, "text/html");
            this.updateQuantityRules(this.dataset.section, e),
            this.setQuantityBoundries()
        }
        )).catch((t => {
            console.error(t)
        }
        )).finally(( () => {
            this.querySelector(".quantity__rules-cart .loading-overlay").classList.add("hidden")
        }
        )))
    }
    updateQuantityRules(t, e) {
        const i = e.getElementById(`Quantity-Form-${t}`)
          , s = [".quantity__input", ".quantity__rules", ".quantity__label"];
        for (let t of s) {
            const e = this.quantityForm.querySelector(t)
              , s = i.querySelector(t);
            if (e && s)
                if (".quantity__input" === t) {
                    const t = ["data-cart-quantity", "data-min", "data-max", "step"];
                    for (let i of t) {
                        const t = s.getAttribute(i);
                        null !== t && e.setAttribute(i, t)
                    }
                } else
                    e.innerHTML = s.innerHTML
        }
    }
}
),
customElements.get("pickup-availability") || customElements.define("pickup-availability", class extends HTMLElement {
    constructor() {
        super(),
        this.hasAttribute("available") && (this.errorHtml = this.querySelector("template").content.firstElementChild.cloneNode(!0),
        this.onClickRefreshList = this.onClickRefreshList.bind(this),
        this.fetchAvailability(this.dataset.variantId))
    }
    fetchAvailability(t) {
        let e = this.dataset.rootUrl;
        e.endsWith("/") || (e += "/"),
        fetch(`${e}variants/${t}/?section_id=pickup-availability`).then((t => t.text())).then((t => {
            const e = (new DOMParser).parseFromString(t, "text/html").querySelector(".shopify-section");
            this.renderPreview(e)
        }
        )).catch((t => {
            const e = this.querySelector("button");
            e && e.removeEventListener("click", this.onClickRefreshList),
            this.renderError()
        }
        ))
    }
    onClickRefreshList(t) {
        this.fetchAvailability(this.dataset.variantId)
    }
    renderError() {
        this.innerHTML = "",
        this.appendChild(this.errorHtml),
        this.querySelector("button").addEventListener("click", this.onClickRefreshList)
    }
    renderPreview(t) {
        const e = document.querySelector("pickup-availability-drawer");
        if (e && e.remove(),
        !t.querySelector("pickup-availability-preview"))
            return this.innerHTML = "",
            void this.removeAttribute("available");
        this.innerHTML = t.querySelector("pickup-availability-preview").outerHTML,
        this.setAttribute("available", ""),
        document.body.appendChild(t.querySelector("pickup-availability-drawer"));
        const i = this.querySelector("button");
        i && i.addEventListener("click", (t => {
            document.querySelector("pickup-availability-drawer").show(t.target)
        }
        ))
    }
}
),
customElements.get("pickup-availability-drawer") || customElements.define("pickup-availability-drawer", class extends HTMLElement {
    constructor() {
        super(),
        this.onBodyClick = this.handleBodyClick.bind(this),
        this.querySelector("button").addEventListener("click", ( () => {
            this.hide()
        }
        )),
        this.addEventListener("keyup", (t => {
            "ESCAPE" === t.code.toUpperCase() && this.hide()
        }
        ))
    }
    handleBodyClick(t) {
        const e = t.target;
        e == this || e.closest("pickup-availability-drawer") || "ShowPickupAvailabilityDrawer" == e.id || this.hide()
    }
    hide() {
        this.removeAttribute("open"),
        document.body.removeEventListener("click", this.onBodyClick),
        document.body.classList.remove("overflow-hidden"),
        removeTrapFocus(this.focusElement)
    }
    show(t) {
        this.focusElement = t,
        this.setAttribute("open", ""),
        document.body.addEventListener("click", this.onBodyClick),
        document.body.classList.add("overflow-hidden"),
        trapFocus(this)
    }
}
),
(() => {
  const t = document.querySelector("product-info") || document.body;
  var unitsMap = {};
  var e = jQuery,
    i = localStorage.getItem("unit"),
    s = localStorage.getItem("width"),
    r = localStorage.getItem("widthEighths"),
    n = localStorage.getItem("height"),
    a = localStorage.getItem("heightEighths");

  const productInfo = document.querySelector("product-info");
  const productType = productInfo.dataset.productType;

  // 工具函数：选择器赋值
  function o(t, i) {
    if (i) {
      var s = e.trim(i),
        r = t
          .find("option")
          .filter(function () {
            return e.trim(e(this).text()) === s;
          })
          .first();
      r.length && t.val(r.val());
    }
  }

  // 工具函数：更新显示在价格下面的尺寸信息
  function updateSizeFor(unit, width, height) {
    const container = document.querySelector(".product-detail-background-info");
    if (!container) return;

    if (container.querySelector(".size-info")) {
      container.querySelector(".size-info").textContent =
        unit === "mm"
          ? `for ${width}mm x ${height}mm`
          : `for ${width}" x ${height}"`;
      return;
    }

    const priceElem = container.querySelector(".total-sales-price");
    const div = document.createElement("div");
    div.classList = "text-xs size-info medium-blue";
    div.innerHTML =
      unit === "mm"
        ? `for ${width}mm x ${height}mm`
        : `for ${width}" x ${height}"`;
    priceElem.appendChild(div);
  }

  // 新增：统一控制 data-after 的函数
  function updateDataAfter(unit, s, n, r, a) {
    const target = e(".size_unit").closest(".fieldset").prev();
    if (!(s && n)) {
      target.attr("data-after", ""); // 没有宽或高 → 清空
      return;
    }

    if (unit === "mm") {
      // 毫米单位
      target.attr("data-after", `Unit: ${unit} ${s} W x ${n} L`);
    } else {
      // 英寸单位
      target.attr(
        "data-after",
        parseInt(r) && parseInt(a)
          ? `Unit: ${unit} ${s} ${r} W x ${n} ${a} L`
          : `Unit: ${unit} ${s} W x ${n} L`
      );
    }
  }

  new MutationObserver((t, l) => {
    if (document.querySelector(".dpo-container")) {
      e(".load-screen").addClass("hidden");
      o(e(".size_unit select"), i);

      if (s !== null) e(".size_width input").val(s);
      if (s !== null && i === "mm")
        e(".size_width .control").attr("data-unit", "(mm)");

      o(e(".width_fraction select"), r);

      if (n !== null) e(".size_length input").val(n);
      if (n !== null && i === "mm")
        e(".size_length .control").attr("data-unit", "(mm)");

      o(e(".height_fraction select"), a);

      if (i === "mm") {
        // 隐藏分数选择器
        e(".width_fraction .field").addClass("ihidden").css({
          height: "0",
          display: "none",
          width: "0",
        });
        e(".height_fraction .field").addClass("ihidden").css({
          height: "0",
          display: "none",
          width: "0",
        });
      }

      // 调用统一的 data-after 设置函数
      updateDataAfter(i, s, n, r, a);
      l.disconnect();
    }

    let h = n ? n : productType === "Roller" ? 39 : 59;
    updateSizeFor(i ? i : "inch", s ? s : 39, h);

    const dpoOptions = document.querySelector(".dpo-container .size_unit");
    const sizeUnit = window.dpoOptions.options.find(
      (o) => o.css_class === "size_unit"
    );

    if (sizeUnit) {
      sizeUnit.items.map((o) => {
        unitsMap[o.option_type_id] = o.title.toLowerCase().trim();
      });
    }

    if (!dpoOptions) return;

    const sizeParent = dpoOptions.closest("table");
    const debouncedUpdate = debounce(() => {
      const unit = sizeParent.querySelector(".size_unit select").value;
      const width = sizeParent.querySelector(".size_width input").value;
      const height = sizeParent.querySelector(".size_length input").value;
      updateSizeFor(unitsMap[unit], width, height);
    }, 300);

    sizeParent && sizeParent.addEventListener("input", debouncedUpdate);
  }).observe(t, {
    childList: true,
    subtree: true,
  });
})();
class SwatchData extends HTMLElement {
    connectedCallback() {
        this.container = this.querySelector(".swatch-container"),
        this.items = Array.from(this.container.children),
        this.prevBtn = this.querySelector(".previousBtn"),
        this.nextBtn = this.querySelector(".nextBtn"),
        this.scrollAmount = 120,
        this.style.position = this.style.position || "relative",
        this.prevBtn && this.nextBtn && (Object.assign(this.prevBtn.style, {
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            left: "6px",
            zIndex: "2"
        }),
        Object.assign(this.nextBtn.style, {
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            right: "6px",
            zIndex: "2"
        }),
        requestAnimationFrame(( () => {
            const t = Math.max(this.prevBtn.offsetWidth || 36, this.nextBtn.offsetWidth || 36);
            this.container.scrollWidth > this.container.clientWidth + 1 && (this.container.style.paddingLeft = `${t + 8}px`,
            this.container.style.paddingRight = `${t + 8}px`)
        }
        ))),
        this.prevBtn.addEventListener("click", ( () => {
            this.container.scrollBy({
                left: -this.scrollAmount,
                behavior: "smooth"
            })
        }
        )),
        this.nextBtn.addEventListener("click", ( () => {
            this.container.scrollBy({
                left: this.scrollAmount,
                behavior: "smooth"
            })
        }
        )),
        this.items.forEach((t => {
            t.addEventListener("click", ( () => {
                this.items.forEach((t => t.classList.remove("active", "loading"))),
                t.classList.add("active", "loading"),
                this.updateImages(t.dataset.value.trim()),
                t.scrollIntoView({
                    behavior: "smooth",
                    inline: "center",
                    block: "nearest"
                })
            }
            ))
        }
        ));
        const t = this.closest(".grid__item").querySelector(".media img");
        t && (t.onload = () => this.items.forEach((t => t.classList.remove("loading")))),
        this._toggleTimeout = null,
        this._ro = new ResizeObserver(( () => {
            clearTimeout(this._toggleTimeout),
            this._toggleTimeout = setTimeout(( () => this.buttonToggle()), 100)
        }
        )),
        this._ro.observe(this.container),
        window.addEventListener("resize", ( () => {
            clearTimeout(this._toggleTimeout),
            this._toggleTimeout = setTimeout(( () => this.buttonToggle()), 120)
        }
        ), {
            passive: !0
        }),
        requestAnimationFrame(( () => this.buttonToggle()))
    }
    disconnectedCallback() {
        this._ro && this._ro.disconnect(),
        window.removeEventListener("resize", this._boundResize)
    }
    buttonToggle() {
        const t = this.container.scrollWidth > this.container.clientWidth + 1
          , e = "none" === this.prevBtn.style.display;
        t && e ? (this.prevBtn.style.display = "",
        this.nextBtn.style.display = "") : t || e || (this.prevBtn.style.display = "none",
        this.nextBtn.style.display = "none")
    }
    updateImages(t) {
        const e = this.getCurrentImages(t);
        this.closest(".grid__item").querySelectorAll(".media img").forEach(( (t, i) => {
            e[i] && (t.setAttribute("srcset", `${e[i]}&width=165 165w,${e[i]}&width=360 360w,${e[i]}&width=533 533w,${e[i]}&width=720 720w,${e[i]}&width=940 940w,${e[i]}&width=1066 1066w,${e[i]} 1500w`),
            t.src = `${e[i]}&width=533`)
        }
        ))
    }
    getCurrentImages(t) {
        const e = this.getData().find((e => e.color.trim() === t));
        return e ? e.images : []
    }
    getData() {
        const t = this.querySelector('[type="application/json"]');
        return t ? JSON.parse(t.textContent) : []
    }
}
customElements.define("swatch-data", SwatchData);
